import { CountUp } from 'use-count-up';

import { count, statisticContainer, statistic } from './donut-card.module.scss';
import { forwardRef } from 'react';

interface Props {
    index: number;
    percentage: number;
    text: string;
    duration: number;
    isActive: boolean;
}

export const DonutCard = forwardRef<HTMLDivElement, Props>(({ index, percentage, text, duration, isActive }, ref) => {
    return (
        <div ref={ref} data-observer-key={String(index)} className={statisticContainer}>
            <div className={statistic}>
                <p>{text}</p>
                <div className={count}>
                    <CountUp
                        isCounting={isActive}
                        start={0}
                        end={percentage}
                        duration={duration}
                        formatter={value => `${value.toFixed(0)}%`}
                    />
                </div>
            </div>
        </div>
    );
});
